import React from 'react'
import { useSelector } from 'react-redux'

const CustomButton = ({ title, type, icon, onClick }) => {
    const darkMode = useSelector(state => state.theme.darkMode);

    let color;
    if (type == 'default') {
        color = '#3a4047';
    } else if (type == 'primary') {
        color = '#3f6791';
    } else if (type == 'warning') {
        color = '#f39c12';
    } else if (type == 'danger') {
        color = '#e74c3c'
    }

    return darkMode
        ?
        <a className={`btn btn-sm btn-${type} mr-2`} onClick={onClick} style={{ cursor: 'pointer', color: '#fff', display: 'inline-block' }}>
            <i className={icon} />
            <span style={{ marginLeft: 10 }}>{title}</span>
        </a>
        :
        <a
            className='mr-2'
            onClick={onClick} style={{ cursor: 'pointer', color: color, display: 'inline-block' }}>
            <i className={icon} />
            <span style={{ marginLeft: 10 }}>{title}</span>
        </a>

}

export default CustomButton;